import styled from '@emotion/styled';
import { FONT, SPACING } from '../../styles/emotion';
import COLORS, { COLORS_SEMANTIC } from '../../styles/emotion/colors3';
import { ButtonV3 } from '../ButtonV3';
import { LinkV2 } from '../LinkV2';
import { XIcon } from '../SvgIconsV3/X';
import { SectionMessageV2Type } from './types';

function borderColor(type: SectionMessageV2Type | undefined) {
  switch (type) {
    case 'confirmation':
      return COLORS_SEMANTIC.POSITIVE_100;
    case 'warning':
      return COLORS_SEMANTIC.WARNING_100;
    case 'error':
      return COLORS_SEMANTIC.NEGATIVE_100;
    default:
      return COLORS_SEMANTIC.INFORMATIONAL_100;
  }
}

export const Container = styled.div<{ type?: SectionMessageV2Type }>`
  display: flex;
  justify-content: space-between;
  padding: ${SPACING.S16};
  border-radius: ${SPACING.S16};
  border: 2px solid;
  border-color: ${(p) => borderColor(p.type)};
`;

export const IconContainer = styled.div`
  display: flex;
  margin-right: ${SPACING.SM};
`;

export const TagContainer = styled.div`
  width: fit-content;
  margin-bottom: ${SPACING.XS};
`;

export const ContentContainer = styled.div`
  display: flex;
`;

export const Title = styled.h2`
  font-size: ${FONT.SIZE.SMALLER};
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
  margin: ${SPACING.XXS} 0;
`;

export const Description = styled.p<{ hasLink: boolean }>`
  font-size: ${FONT.SIZE.SMALLER};
  color: ${COLORS.BLACK_075};
  margin-bottom: ${({ hasLink }) => (hasLink ? SPACING.XS : 0)};
`;

export const StyledLink = styled(LinkV2)`
  font-size: ${FONT.SIZE.SMALLER};
`;

export const StyledButton = styled(ButtonV3)`
  height: fit-content;
  padding: 0;
`;

export const StyledXIcon = styled(XIcon)`
  color: ${COLORS.BLACK_100};
`;
